import React from 'react';

// Note: unlike other modals in the app, Escape intentionally does nothing
// here. This modal blocks stock-check entry until the user picks Delete or
// Continue; neither action is a safe silent default for Escape to trigger.
const DraftBlockerModal = ({ isOpen, draftToBlock, onDelete, onContinue }) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/50 backdrop-blur-sm animate-fade-in"
      role="dialog"
      aria-modal="true"
      aria-labelledby="draft-blocker-title"
    >
      <div className="bg-white dark:bg-slate-800 rounded-2xl shadow-xl w-full max-w-md overflow-hidden flex flex-col transform transition-all animate-scale-in">
        <div className="px-5 py-4 border-b border-slate-100 dark:border-slate-700 bg-amber-50 dark:bg-amber-500/10 flex items-center justify-between">
          <h3 id="draft-blocker-title" className="text-base font-bold text-amber-800 dark:text-amber-500 flex items-center gap-2">
            <i className="fas fa-exclamation-triangle" aria-hidden="true"></i>
            Unfinished Draft Found
          </h3>
        </div>
        <div className="p-5 text-sm text-slate-600 dark:text-slate-300">
          <p className="mb-4">You have an unfinished Draft for today. Would you like to continue from where you left off, or delete it and start fresh?</p>
          {draftToBlock && (
            <div className="bg-slate-50 dark:bg-slate-900/50 p-3 rounded-lg border border-slate-100 dark:border-slate-700 mb-4 font-mono text-xs text-slate-500 flex justify-between">
              <span>Draft Date: {draftToBlock.check_date.split('T')[0]}</span>
              <span>Version: {draftToBlock.version}</span>
            </div>
          )}
          <div className="flex gap-3 justify-end mt-2">
            <button
              onClick={onDelete}
              className="px-4 py-2 bg-rose-50 hover:bg-rose-100 text-rose-600 rounded-lg font-bold transition-colors"
            >
              Delete Draft
            </button>
            <button
              onClick={onContinue}
              className="px-4 py-2 bg-amber-500 hover:bg-amber-600 text-white rounded-lg font-bold shadow hover:shadow-lg transition-all"
            >
              Continue Draft
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DraftBlockerModal;
